import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAccountData } from '@app/models/account-data.model';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Constants } from 'src/app/constants';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private account$: Observable<IAccountData>;

  constructor(private http: HttpClient) {}

  /**
   * Gets credit union name
   * @param { AccountId }
   * @returns credit union name
   */
  public getAccount({ AccountId }): Observable<IAccountData> {
    if (!this.account$) {
      this.account$ = this.http
        .get<IAccountData>(
          `${Constants.appConfiguration.apiRoot}/Accounts/${AccountId}`
        )
        .pipe(shareReplay(1));
    }
    return this.account$;
  }
}
